import { readReactions } from './read'

export const reactions = {
  read: readReactions,
}
